"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _UIAbstractIconDropdown = _interopRequireDefault(require("./abstract/UIAbstractIconDropdown"));

var _UITextToolbarButton = _interopRequireDefault(require("./UITextToolbarButton"));

var _UITextToolbarIcon = _interopRequireDefault(require("./UITextToolbarIcon"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIButtonGroup = _interopRequireDefault(require("../button/UIButtonGroup"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var UITextToolbarSplitSelect =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UITextToolbarSplitSelect, _Component);

  function UITextToolbarSplitSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITextToolbarSplitSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITextToolbarSplitSelect).call(this, props));
    _this.refCallback = _this.refCallback.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UITextToolbarSplitSelect, [{
    key: "refCallback",
    value: function refCallback(element) {
      this._popoverTarget = (0, _reactDom.findDOMNode)(element);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          open = _this$props.open,
          options = _this$props.options,
          onButtonClick = _this$props.onButtonClick,
          placement = _this$props.placement,
          tooltip = _this$props.tooltip,
          value = _this$props.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["active", "open", "options", "onButtonClick", "placement", "tooltip", "value"]);
      var selectedOption = options.find(function (_ref) {
        var val = _ref.value;
        return val === value;
      });
      var renderedIcon = selectedOption ? _react.default.createElement(_UITextToolbarIcon.default, {
        name: selectedOption.icon
      }) : null;
      var popoverProps = {
        target: this._popoverTarget
      };
      return _react.default.createElement(_UITooltip.default, {
        open: open ? false : undefined,
        placement: placement,
        title: tooltip
      }, _react.default.createElement(_UIButtonGroup.default, null, _react.default.createElement(_UITextToolbarButton.default, {
        hovered: open ? true : undefined,
        onClick: onButtonClick,
        ref: this.refCallback,
        selected: active
      }, renderedIcon), _react.default.createElement(_UIAbstractIconDropdown.default, (0, _extends2.default)({
        open: open,
        options: options,
        popoverProps: popoverProps,
        value: value
      }, rest))));
    }
  }]);
  return UITextToolbarSplitSelect;
}(_react.Component);

UITextToolbarSplitSelect.propTypes = (0, _extends2.default)({}, _UIAbstractIconDropdown.default.propTypes, {
  active: _react.PropTypes.bool,
  onButtonClick: _react.PropTypes.func,
  placement: _UITooltip.default.propTypes.placement,
  tooltip: _UITooltip.default.propTypes.title
});
UITextToolbarSplitSelect.defaultProps = (0, _extends2.default)({}, _UIAbstractIconDropdown.default.defaultProps, {
  active: false,
  placement: 'bottom'
});
UITextToolbarSplitSelect.displayName = 'UITextToolbarSplitSelect';

var _default = (0, _Controllable.default)(UITextToolbarSplitSelect, ['open', 'value']);

exports.default = _default;
module.exports = exports.default;